import { fetchApi } from 'containers/helpers';

export const getAppointment = (appointmentId, isBtob) =>
fetchApi(`/appointment/${appointmentId}?plateform=${isBtob ? '0' : '1'}`);
